// src/components/ProfileSettings.js
import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthProvider';
import { auth, firestore, storage, timestamp } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, setDoc } from 'firebase/firestore';

export default function ProfileSettings() {
  const { user } = useAuth();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(user?.photoURL || '');
  const [uploading, setUploading] = useState(false);

  // Generate local preview URL
  useEffect(() => {
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const handleFileChange = e => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);
    try {
      // Upload to Firebase Storage under avatars/<uid>
      const storageRef = ref(storage, `avatars/${user.uid}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      // Update Firebase Authentication profile
      await auth.currentUser.updateProfile({ photoURL: url });

      // Update Firestore users collection
      const userDocRef = doc(firestore, 'users', user.uid);
      await setDoc(
        userDocRef,
        {
          displayName: user.displayName,
          photoURL: url,
          updatedAt: timestamp()
        },
        { merge: true }
      );

      alert('Avatar updated successfully!');
      setFile(null);
    } catch (err) {
      console.error('Upload error:', err);
      alert('Failed to upload avatar.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h2>Profile Settings</h2>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
          {preview && (
            <img
              src={preview}
              alt="Avatar Preview"
              className="avatar"
              style={{ width: 80, height: 80, borderRadius: '50%' }}
            />
          )}
          <input type="file" accept="image/*" onChange={handleFileChange} />
          <button onClick={handleUpload} disabled={uploading || !file}>
            {uploading ? 'Uploading...' : 'Upload Avatar'}
          </button>
        </div>
      </div>
    </div>
  );
}